import { API } from 'types/frontend/shared';

export const READ_CONTENT_POINT_SETTING: API = { method: 'GET', path: '/academy/0/setting/contentPoint' };
export const UPDATE_CONTENT_POINT_SETTING: API = { method: 'PUT', path: '/academy/0/setting/contentPoint' };
export const DO_CHARGE_CONTENT_POINTS: API = { method: 'POST', path: '/academy/0/setting/contentPoint/charge' };

//
// 출결
//

// 출결 설정 읽기
export const READ_ATT_SETTING: API = {
  method: 'GET',
  path: `/academy/0/setting/attendance`,
};

// 출결 설정 수정
export const UPDATE_ATT_SETTING: API = {
  method: 'PUT',
  path: `/academy/0/setting/attendance`,
};

//
// 메시지
//

// 메시지 충전/사용 읽기

// READ_MESSAGE_STATS 는 network/shared/message로 이동함

// 메시지 설정 읽기
export const READ_MESSAGE_SETTING: API = {
  method: 'GET',
  path: `/academy/0/setting/message`,
};

// 메시지 설정 수정
export const UPDATE_MESSAGE_SETTING: API = {
  method: 'PUT',
  path: `/academy/0/setting/message`,
};

export const UPDATE_MESSAGE_SOL_SETTING: API = {
  method: 'PUT',
  path: '/academy/0/setting/message/solapi',
};

export const DELETE_MESSAGE_SOL_SETTING: API = {
  method: 'DELETE',
  path: '/academy/0/setting/message/solapi',
};

//
// 상담톡
//

// 상담톡 설정 읽기
export const READ_CHAT_SETTING: API = {
  method: 'GET',
  path: `/academy/0/setting/chat`,
};

// 상담톡 설정 수정
export const UPDATE_CHAT_SETTING: API = {
  method: 'PUT',
  path: `/academy/0/setting/chat`,
};

//
// 결제정보
//

// 원 기능 이벤트/파트너/프로모션 내역 읽기
export const READ_ACADEMY_FEATURE_HISTORY_LIST: API = {
  method: 'GET',
  path: `/academy/0/setting/featureHistoryList`,
};

// 결제정보 읽기
export const READ_BILLING_INFO: API = {
  method: 'GET',
  path: `/academy/0/setting/billingInfo`,
};

// 결제정보 등록/수정 (access_token 기반)
export const CREATE_BILLING_INFO: API = {
  method: 'POST',
  path: `/academy/0/setting/billingInfo`,
};

//
// 출결
//

// 출결 설정 읽기
export const READ_HOMEWORK_SETTING: API = {
  method: 'GET',
  path: `/academy/0/setting/homework`,
};

// 출결 설정 수정
export const UPDATE_HOMEWORK_SETTING: API = {
  method: 'PUT',
  path: `/academy/0/setting/homework`,
};

//
// 학원비
//

// 학원비 설정 읽기
export const READ_BILL_SETTING: API = {
  method: 'GET',
  path: `/academy/0/setting/bill`,
};

// 학원비 설정 수정
export const UPDATE_BILL_SETTING: API = {
  method: 'PUT',
  path: `/academy/0/setting/bill`,
};

//
// 교재
//

// 교재 설정 읽기
export const READ_TEXTBOOK_SETTING: API = {
  method: 'GET',
  path: `/academy/0/setting/textbook`,
};

// 교재 설정 수정
export const UPDATE_TEXTBOOK_SETTING: API = {
  method: 'PUT',
  path: `/academy/0/setting/textbook`,
};

//
// 학원 편집
//
export const UPDATE_ACADEMY_EDITABLE_SETTING: API = {
  method: 'PUT',
  path: `/academy/0/setting/academyEditable`,
};

//
// 사용자별
//

export const READ_ACADEMY_USER_SETTING = (academyId: number): API => ({
  method: 'GET',
  path: `/academy/${academyId}/userSetting`,
});

export const UPDATE_ACADEMY_USER_SETTING = (academyId: number): API => ({
  method: 'PUT',
  path: `/academy/${academyId}/userSetting`,
});
